module.exports = __webpack_public_path__ + "static/media/Stephanie W.89ee5590.jpeg";